import ReactOnRails from 'react-on-rails';
import ScreeningToolResponseApp from "../bundles/ScreeningToolResponse/ScreeningToolResponseApp";

ReactOnRails.register({
  ScreeningToolResponseApp,
});
